package br.com.texeratx.boardgametimeapp.ui.screens.signup

import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.koin.getScreenModel
import cafe.adriel.voyager.navigator.LocalNavigator
import cafe.adriel.voyager.navigator.currentOrThrow

class SignupScreen : Screen {

    @Composable
    override fun Content() {
        val navigator = LocalNavigator.currentOrThrow
        val viewModel = getScreenModel<SignupViewModel>()
        val state by viewModel.state.collectAsState()

        SignupUI(
            state = state,
            onDisplayNameChange = viewModel::updateDisplayName,
            onEmailChange = viewModel::updateEmail,
            onPasswordChange = viewModel::updatePassword,
            onConfirmPasswordChange = viewModel::updateConfirmPassword,
            onSignupClick = { viewModel.signup(navigator) },
            onGoToLogin = { navigator.pop() }
        )
    }
}
